var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAverageRanl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_170107",
    "data-name": "Group 170107",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150969",
    "data-name": "Rectangle 150969",
    width: 80,
    height: 80,
    rx: 12,
    fill: "rgba(118,200,206,0.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41968",
    "data-name": "Path 41968",
    d: "M27.639,4.191,25.795.457a.889.889,0,0,0-1.594,0L22.358,4.191l-4.086.586a.91.91,0,0,0-.5,1.547l2.969,2.89-.7,4.07a.912.912,0,0,0,1.312.953L25.014,12.3l3.64,1.906a.911.911,0,0,0,1.312-.953l-.7-4.07,2.969-2.859a.913.913,0,0,0-.5-1.547l-4.086-.586ZM20,19.963a2.5,2.5,0,0,0-2.5,2.5v15a2.5,2.5,0,0,0,2.5,2.5H30a2.5,2.5,0,0,0,2.5-2.5v-15a2.5,2.5,0,0,0-2.5-2.5Zm-17.5,5a2.5,2.5,0,0,0-2.5,2.5v10a2.5,2.5,0,0,0,2.5,2.5h10a2.5,2.5,0,0,0,2.5-2.5v-10a2.5,2.5,0,0,0-2.5-2.5Zm32.5,7.5v5a2.5,2.5,0,0,0,2.5,2.5h10a2.5,2.5,0,0,0,2.5-2.5v-5a2.5,2.5,0,0,0-2.5-2.5h-10A2.5,2.5,0,0,0,35,32.463Z",
    transform: "translate(15.002 20.038)",
    fill: "#76c8ce"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageRanl);
export default __webpack_public_path__ + "static/media/average-ranl.8cb0a225665f7d8e433c96ab58060e02.svg";
export { ForwardRef as ReactComponent };